"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthErrorMessage = exports.AuthDtoKeys = exports.OAuthKeys = void 0;
var OAuthKeys;
(function (OAuthKeys) {
    OAuthKeys["CLIENT_ID"] = "client_id";
    OAuthKeys["REDIRECT_URI"] = "redirect_uri";
    OAuthKeys["RESPONSE_TYPE"] = "response_type";
    OAuthKeys["STATE"] = "state";
    OAuthKeys["APP_NAME"] = "app_name";
})(OAuthKeys || (exports.OAuthKeys = OAuthKeys = {}));
/**
 * The AuthCode expected field constants
 */
var AuthDtoKeys;
(function (AuthDtoKeys) {
    AuthDtoKeys["TENANT_ID"] = "tenant-id";
    AuthDtoKeys["USER_ID"] = "user-id";
    AuthDtoKeys["CODE"] = "code";
})(AuthDtoKeys || (exports.AuthDtoKeys = AuthDtoKeys = {}));
/**
 * Error messages associated with an authentication attempt.
 */
var AuthErrorMessage;
(function (AuthErrorMessage) {
    /**
     * An error message related to the banned user.
     */
    AuthErrorMessage["banned"] = "banned";
    /**
     * An error message related to the username or password.
     */
    AuthErrorMessage["credentials"] = "credentials";
    /**
     * An error message related to too many login attempts.
     */
    AuthErrorMessage["limit"] = "limit";
    /**
     * An unknown error message.
     */
    AuthErrorMessage["unknown"] = "unknown";
})(AuthErrorMessage || (exports.AuthErrorMessage = AuthErrorMessage = {}));
//# sourceMappingURL=index.js.map